<template>
  <section class="content">
    <div class="container-fluid">
      <div class="card">
        <div class="card-body">
          <div class="row">
            <div
              class="col-md-4 d-flex justify-content-center align-items-center"
            >
              <b-skeleton 
                type="avatar"
                class="detail-image"
                width="250px"
                height="250px"
              ></b-skeleton>
            </div>
            <div class="col-md-8 info-detail">
              <b-skeleton width="150px"></b-skeleton>
              <b-skeleton width="100px"></b-skeleton>
              <b-skeleton width="200px"></b-skeleton>
            </div>
          </div>
        </div>
      </div>
      <div class="card m-md-3">
        <div class="card-body">
          <div class="tab-content">
            <div class="row mb-3">
              <div class="col-md-6">
                <b-skeleton width="40%" class="h3-skeleton"></b-skeleton>
                <b-skeleton width="40%"></b-skeleton>
              </div>
              <div class="col-md-6">
                <b-skeleton width="40%" class="h3-skeleton"></b-skeleton>
                <b-skeleton
                  type="input"
                  class="rounded-pill"
                  width="150px"
                ></b-skeleton>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <b-skeleton width="40%" class="h3-skeleton"></b-skeleton>
                <b-skeleton width="90%"></b-skeleton>
                <b-skeleton width="60%"></b-skeleton>
                <b-skeleton width="75%"></b-skeleton>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card m-md-3">
        <div class="card-header">
          <b-skeleton type="input" class="btn add-button rounded-pill"></b-skeleton>
          <div class="card-tools">
            <div class="d-flex filter-container">
              <b-skeleton type="input" class="mr-3 search-bar"> </b-skeleton>
              <b-skeleton type="input" class="input-search"></b-skeleton>
            </div>
          </div>
        </div>
        <div class="card-body table-responsive p-0">
          <b-skeleton-table :rows="8" :columns="6"></b-skeleton-table>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "RDetailSkeleton",
};
</script>

<style scoped>
@media only screen and (max-width: 767.9px) {
  .info-detail {
    align-items: center;
    padding-top: 1rem;
  }
}
@media only screen and (max-width: 601px) {
  .card-header {
    flex-direction: column;
    align-items: center;
  }
  .card-tools {
      width: 100%;
      margin: 0!important;
  }
  .add-button {
    width: 100%!important;
    margin-bottom: 0.75rem;
  }
  .input-search {
    width: 100% !important;
  }
  .filter-container {
    width: 100%!important;
    flex-direction: column !important;
  }
  .search-bar,
  .select-perpage {
    margin-bottom: 0.75rem;
    width: 100% !important;
  }
}
.add-button {
    width: 100px;
    cursor: wait;
}
.search-bar {
    width: 25%;
}
.input-search {
    width: 75%;
}
.filter-container {
    width: 300px;
}
.info-detail {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 1rem !important;
}
.card-header {
  display: flex;
  justify-content: space-between;
}
.card-header::after {
  display: none !important;
  content: "";
}
.h3-skeleton {
    height: 1.75em;
    margin-bottom: 1rem;
}
</style>